
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"34","viewBox":"0 0 34 34","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"width":"34","height":"34","rx":"3","fill":"#ABD3C3"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M10 7h14v12.6l-7 7-7-7V7z","fill":"#009586"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M17 12.6l7 7-7 7v-14z","fill":"#FCBF00"}})])
          )
        }
      }
    